import { ScreenHeader } from '@app/components/screen-header'
import { EmirList } from '@app/features/uretim/emir-list'
import { ProductionBoard } from '@app/features/uretim/board'

/**
 * Production — a single two-tier screen.
 *
 * The process board on top (where the shop floor is currently jammed), the
 * emir list below. Both are populated on open: this replaces Korgun's
 * "criteria form first, then a results tab" layout.
 */
export function ProductionScreen() {
  return (
    <>
      <ScreenHeader
        title="Üretim"
        description="Proseslerdeki açık iş ve emir bazında ilerleme."
      />

      <div className="flex flex-col gap-4">
        <ProductionBoard />
        <EmirList />
      </div>
    </>
  )
}
